export { Body, type BodyProps } from "./Body";
